
<template>
    <Modal v-if="modals.updateLog" :windowSize="false" @close="close">
        <div class="UpdateLog">
            <h2>2022-5-25更新</h2>
            <p>1、更新教派&紫罗兰预置卡组</p>
            <p>2、修复ipad适配问题</p>
            <p>3、修复主机断线重连问题</p>
            <h2>2022-5-23更新</h2>
            <p>1、创建房间删除玩家</p>
            <p>2、加入房间删除标记</p>
            <p>3、私聊不要一直回弹</p>
            <p>4、PC名字字号变小</p>
            <p>5、私聊加到头像上，加到右上角</p>
            <p>6、分配角色清除所有角色</p>
            <p>7、移动端右上角设置框变大</p>
            <p>8、自定义标记居中</p>
            <p>9、被分配恶魔群聊才能看到按钮</p>
            <p>10、私聊会话列表加头像</p>
            <p>11、添加一键坐下按钮</p>
            <p>12、分配角色时确认是否删除当前标记</p>
            <h2>2022-5-16更新</h2>
            <p>1、添加了说书人私聊按钮</p>
            <p>2、添加了恶魔群聊功能</p>
            <p>3、优化了移动端页面排版</p>
            <h2>2022-5-10更新</h2>
            <p>1、甄嬛传，内容优化</p>
            <p>2、选择剧本，页面优化</p>
            <p>3、上新剧本：长坂坡</p>
            <p>4、预设卡组更新，8人，折磨的共情</p>
            <h2>2022-4-25更新</h2>
            <p>1、优化了三国剧本</p>
            <p>2、优化了末日钟声剧本</p>
            <p>3、添加了三国预置卡组</p>
            <h2>2022-4-21更新</h2>
            <p>1、创建房间时增加输入玩家人数功能，方便一键生成对应人数的玩家座位；</p>
            <p>2、在“魔法书”选项卡新增玩家海报生成功能，海报支持自定义“玩家名称、获得称号、线下店铺信息及二维码”等功能；</p>
            <img src="../../assets/updateLog/updateLog1.png">
                <img src="../../assets/updateLog/updateLog2.png">
            <p>3、新增两套“三国”剧本模组</p>
            <img src="../../assets/updateLog/updateLog3.png">
            <h2>2022-4-20</h2>
            <p>1、新增倒计时小组件功能，方便说书人记录每一轮白天的聊天时长；</p>
            <p>2、选择甄嬛传剧本将更换背景图；</p>
            <p>3、帮助菜单中增加灾祸滋生预设卡组一键导入功能，方便说书人选择不同卡组快速开始游戏；目前灾祸滋生的多套卡组为经过测试的最佳体验版本；</p>
            <img src="../../assets/updateLog/updateLog4.png">
            <h2>2022-4-18</h2>
            <p>1、新增玩家自创的“甄嬛传”剧本</p>
            <p>2、增加复制当前工具链接按钮，方便手机端复制链接并通过微信等软件发到PC上打开使用；</p>
        </div>
    </Modal>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import Modal from "./Modal";
export default {
    name: "UpdateLog",
    components: { Modal },
    computed: {
        ...mapState(["modals"]),
    },
    methods: {
        close() {
            this.toggleModal("updateLog");
        },
        ...mapMutations(["toggleModal"])
    }
};
</script>
<style lang="scss" scoped>
    .UpdateLog{
        width: 80%;
        height: 100%;
        margin: 0 auto;
        overflow-y: auto;
        img{
            display: block;
            max-width: 300px;
            margin: 0 auto 20px;
        }
        p{
            text-align: center;
            font-size: .8em;
        }
    }
</style>
